export default __webpack_public_path__ + "static/media/dieppe9.01ae6b9e.jpg";